import { Injectable } from '@angular/core';
import { Data } from '@angular/router';
import { isUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class BusinessDayService {

  constructor() { }

  SetDueDate(DueDate: Data, Holiday: Data[]) {
    var startDate = new Date();
    var endDate = DueDate;
    var days;
    if (startDate > endDate) {
      days = this.pastBusinessDay(startDate, DueDate, Holiday)
    } else {
      days = this.futureBusinessDay(startDate, DueDate, Holiday)
    }
    return days;
  }

  setDueDatebyDate(dStartDate: Data, DueDate: Data, Holiday: Data[]) {
    //var startDate = dStartDate;
    var startDate = this.SetToday(Holiday);
    //startDate.setDate(startDate.getDate() + (startDate.getHours() >= 17 ? 0 : -1));
    startDate = this.SetNextDate(startDate, Holiday);
    var endDate = DueDate;
    var days;
    if (startDate > endDate) {
      days = this.pastBusinessDay(startDate, DueDate, Holiday)
    } else {
      days = this.futureBusinessDay(startDate, DueDate, Holiday, startDate.getHours())
    }
    return days;
  }

  //past Day
  private pastBusinessDay(dStartDate: Data, DueDate: Data, Holiday: Data[]) {
    var startDate = dStartDate;
    var endDate = DueDate;
    var millisecondsPerDay = 86400 * 1000; // Day in milliseconds
    var D1 = startDate.setHours(23, 59, 59, 999);  // Start just after midnight
    var D2 = endDate.setHours(0, 0, 0, 1);  // End just before midnight
    var diff = D2 - D1;  // Milliseconds between datetime objects    
    var days = Math.ceil(diff / millisecondsPerDay);
    var weeks = (days / 7);
    weeks = Math.round(weeks)
    days -= weeks * 2;

    // Handle special cases
    var startDay = startDate.getDay();
    var endDay = endDate.getDay();

    // Remove weekend not previously removed. 
    if (startDay - endDay > 1) {
      days -= 2;
    }
    if (Holiday != undefined && Holiday != null) {
      Holiday.forEach(day => {
        if ((day >= endDate) && (day <= startDate)) {
          /* If it is not saturday (6) or sunday (0), substract it */
          if ((day.getDay() % 6) != 0) {
            days++;
          }
        }
      });
    }


    return days;
  }
  //future Day
  private futureBusinessDay(dStartDate: Data, DueDate: Data, Holiday: Data[], dStartTime: any = 0) {
    var startDate = dStartDate;
    var endDate = DueDate;
    var millisecondsPerDay = 86400 * 1000; // Day in milliseconds
    var D1 = startDate.setHours(0, 0, 0, 1);  // Start just after midnight
    var D2 = endDate.setHours(23, 59, 59, 999);  // End just before midnight
    var diff = D2 - D1;  // Milliseconds between datetime objects    
    var days = Math.ceil(diff / millisecondsPerDay);
    var weeks = Math.floor(days / 7);
    days -= weeks * 2;

    var startDay = startDate.getDay();
    var endDay = endDate.getDay();

    // Remove weekend not previously removed. 
    if (startDay - endDay > 1) {
      days -= 2;
    }

    if (Holiday != undefined && Holiday != null) {
      Holiday.forEach(day => {
        if ((day >= startDate) && (day <= endDate)) {
          /* If it is not saturday (6) or sunday (0), substract it */
          if ((day.getDay() % 6) != 0) {
            days--;
          }
        }
      });
    }
    if (dStartTime >= 17) {
      days--;
    }
    return days;
  }

  public SetToday(Holiday: Data[]) {
    let today = new Date();
    if (Holiday != undefined) {
      let day = 0;
      let round = 0;
      let count_d = 0;
      let Dates = today.toLocaleDateString('en');
      let arrHoliday = Holiday.map(h => h.toLocaleDateString('en'));
      do {
        round++;
        //check date holiday
        if (arrHoliday.length != 0) {
          arrHoliday.forEach(h => {
            if (h == Dates) {
              /* If it is not saturday (6) or sunday (0), substract it */
              let _Date = new Date(h);
              if ((_Date.getDay() % 6) != 0) {
                day++;
                count_d++;
              }
            }
          });
        }
        today.setDate(today.getDate() + day);
        day = 0;
        Dates = today.toLocaleDateString('en');
        //check date weekend
        if ((today.getDay() % 6) == 0) {
          if (today.getDay() == 6) {
            day = day + 2;
            count_d = count_d + 2;
          } else {
            day++
            count_d++;
          }
        }

        today.setDate(today.getDate() + day);
        Dates = today.toLocaleDateString('en');
        day = 0;

      } while (round < 3);
      //let _today = today.setHours(0, 0, 0, 1);
      //let _holiday = Holiday.map(h => h.setHours(0, 0, 0, 1))
      //if (Holiday.length != 0) {
      //  _holiday.forEach(h => {
      //    if (h == _today) {
      //      /* If it is not saturday (6) or sunday (0), substract it */
      //      let _Date = new Date(h);
      //      if ((_Date.getDay() % 6) != 0) {
      //        day++;
      //      }
      //    }
      //  });
      //}
      ////weekend;
      //today.setDate(today.getDate() + day);
      //day = 0;
      //if ((today.getDay() % 6) == 0) {
      //  if (today.getDay() == 6) {
      //    day = day + 2;
      //  } else {
      //    day++
      //  }
      //}

      //today.setDate(today.getDate() + day);
      //_today = today.setHours(0, 0, 0, 1);
      //day = 0;
      //if (Holiday.length != 0) {
      //  _holiday.forEach(h => {
      //    if (h == _today) {
      //      /* If it is not saturday (6) or sunday (0), substract it */
      //      let _Date = new Date(h);
      //      if ((_Date.getDay() % 6) != 0) {
      //        day++;
      //      }
      //    }
      //  });
      //}


      today.setDate(today.getDate() + day);
      return today;
    } else {
      return today;
    }
  }

  public SetNextDate(_date: Date, Holiday: Data[]) {
    if (Holiday != undefined) {
      let day = 0;
      let round = 0;
      let count_d = 0;
      let Dates = _date.toLocaleDateString('en');
      let arrHoliday = Holiday.map(h => h.toLocaleDateString('en'));
      do {
        round++;
        //check date holiday
        if (arrHoliday.length != 0) {
          arrHoliday.forEach(h => {
            if (h == Dates) {
              /* If it is not saturday (6) or sunday (0), substract it */
              let _Date = new Date(h);
              if ((_Date.getDay() % 6) != 0) {
                day++;
                count_d++;
              }
            }
          });
        }
        _date.setDate(_date.getDate() + day);
        day = 0;
        Dates = _date.toLocaleDateString('en');
        //check date weekend
        if ((_date.getDay() % 6) == 0) {
          if (_date.getDay() == 6) {
            day = day + 2;
            count_d = count_d + 2;
          } else {
            day++
            count_d++;
          }
        }

        _date.setDate(_date.getDate() + day);
        Dates = _date.toLocaleDateString('en');
        day = 0;

      } while (round < 3);


      _date.setDate(_date.getDate() + day);
      return _date;
    } else {
      return _date;
    }
  }
}
